import { render, staticRenderFns } from "./fieldSetting.vue?vue&type=template&id=6fc5e370&scoped=true"
import script from "./fieldSetting.vue?vue&type=script&lang=js"
export * from "./fieldSetting.vue?vue&type=script&lang=js"
import style0 from "./fieldSetting.vue?vue&type=style&index=0&id=6fc5e370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5e370",
  null
  
)

export default component.exports